import { render, staticRenderFns } from "./UserMain.vue?vue&type=template&id=5bee42e2&scoped=true&lang=html"
import script from "./UserMain.vue?vue&type=script&lang=js"
export * from "./UserMain.vue?vue&type=script&lang=js"
import style0 from "./UserMain.vue?vue&type=style&index=0&id=5bee42e2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bee42e2",
  null
  
)

export default component.exports